<template>
  <div>
    <div class="welcome-dialog-section">
      <div class="welcome-container white">
        <transition name="fade" mode="out-in">
          <keep-alive>
            <template>
              <!-- COMPONENT BLOCK -->
              <!-- <component :is="tab"></component> -->
              <DialogOne
                v-if="current_tab === 0 && account_type === 'school'"
                banner="DialogOne.png"
                display_img="GradelyIcon.png"
              ></DialogOne>

              <DialogOne
                v-if="current_tab === 0 && account_type === 'teacher'"
                banner="TeacherDialog.png"
                display_img="GradelyIcon.png"
              ></DialogOne>

              <DialogOne
                v-if="current_tab === 0 && account_type === 'parent'"
                banner="ParentDialog.png"
                display_img="GradelyIcon.png"
              ></DialogOne>

              <DialogOne
                v-if="current_tab === 0 && account_type === 'student'"
                banner="StudentDialog.png"
                display_img="GradelyIcon.png"
              ></DialogOne>

              <DialogTwo
                v-else-if="current_tab === 1"
                banner="DisplayBanner.png"
                display_img="DialogTwo.png"
              ></DialogTwo>

              <DialogThree
                v-else-if="current_tab === 2"
                banner="DisplayBanner.png"
                display_img="DialogThree.png"
              ></DialogThree>

              <DialogFour
                v-else-if="current_tab === 3"
                banner="DisplayBanner.png"
                display_img="DialogFour.png"
              ></DialogFour>

              <DialogFive
                v-else-if="current_tab === 4"
                banner="DisplayBanner.png"
                display_img="DialogFour.png"
              ></DialogFive>
              <!-- COMPONENT BLOCK -->
            </template>
          </keep-alive>
        </transition>

        <!-- NAVIGATION BLOCK -->
        <div
          class="navigation-block w-100 d-flex flex-column justify-content-start align-items-center"
        >
          <template v-if="account_type === 'student'">
            <router-link
              to
              @click.native="$emit('closeDialog')"
              class="btn btn-accent next-btn"
              v-if="hasRelationship"
              >Continue</router-link
            >

            <router-link
              to
              @click.native="redirectToParentInvitePage"
              class="btn btn-accent next-btn"
              v-else
              >Invite Your Parent</router-link
            >
          </template>
          <button class="btn btn-accent next-btn" @click="nextTab" v-else>
            Next
          </button>

          <button
            class="btn btn-accent done-btn d-none"
            v-if="account_type !== 'parent'"
            @click="$emit('closeDialog')"
          >
            Done
          </button>

          <template v-else>
            <router-link
              to
              v-if="hasRelationship"
              @click.native="$emit('closeDialog')"
              class="btn btn-accent done-btn mb-4 d-none"
              >Continue</router-link
            >
            <router-link
              to
              v-else
              @click.native="redirectToAddChildPage"
              class="btn btn-accent done-btn mb-4 d-none"
              >Add a Child</router-link
            >
          </template>

          <div
            class="navigations d-flex justify-content-center align-items-start"
            v-if="account_type !== 'student'"
          >
            <div
              class="nav rounded-circle border_grey_bg"
              v-for="(tab, index) in tabs"
              :key="index"
              :class="[current_tab === index ? 'active' : '']"
              @click="changeTab(tab, index)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DialogOne from "@/components/schoolComps/welcome/welcomeComps/DialogOne.vue";
import DialogTwo from "@/components/schoolComps/welcome/welcomeComps/DialogTwo.vue";
import DialogThree from "@/components/schoolComps/welcome/welcomeComps/DialogThree.vue";
import DialogFour from "@/components/schoolComps/welcome/welcomeComps/DialogFour.vue";
import DialogFive from "@/components/schoolComps/welcome/welcomeComps/DialogFive.vue";

export default {
  name: "WelcomeDialog",

  components: {
    DialogOne,
    DialogTwo,
    DialogThree,
    DialogFour,
    DialogFive,
  },

  computed: {
    ...mapGetters(["getAuthUser"]),

    hasRelationship() {
      return this.getAuthUser.relationship;
    },
  },

  data() {
    return {
      tab: DialogOne,
      account_type: "",
      current_tab: 0,
      tabs: [DialogOne, DialogTwo, DialogThree, DialogFour, DialogFive],
    };
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    nextTab() {
      this.tab = this.tabs[this.current_tab + 1];
      this.current_tab === this.current_tab++;
      this.checklastTab();
    },

    changeTab(tab, index) {
      this.tab = tab.name;
      this.current_tab = index;
      this.checklastTab();
    },

    checklastTab() {
      let nextBtn = document.querySelector(".next-btn");
      let doneBtn = document.querySelector(".done-btn");

      if (this.current_tab === 4) {
        nextBtn.classList.add("d-none");
        doneBtn.classList.remove("d-none");
      } else {
        nextBtn.classList.remove("d-none");
        doneBtn.classList.add("d-none");
      }
    },

    redirectToParentInvitePage() {
      this.$emit("updateBoarded");
      this.$router.push({ name: "ParentInvitation" });
    },

    redirectToAddChildPage() {
      this.$emit("updateBoarded");
      this.$router.push({ name: "ParentNewChildOnboarding" });
    },
  },
};
</script>

<style></style>
